export const analyticsTestIds = {
  localAnalyticsLink: 'local_analytics_link',
  analyticsLink: 'analytics_link',
  localAstroAnalyticsLink: 'local_astro_analytics_link',
  astroAnalyticsLink: 'astro_analytics_link',
};
